import React from 'react';
import { Box, SkeletonGroup, Layout, Cell, SkeletonRectangle } from '@wix/design-system';
import styles from './styles.scss';
export const SkeletonRowLoader = () => /*#__PURE__*/React.createElement(SkeletonGroup, null, [...Array(3)].map(() => /*#__PURE__*/React.createElement(Box, {
  className: styles.skeletonBox
}, /*#__PURE__*/React.createElement(Layout, {
  gap: "36px"
}, /*#__PURE__*/React.createElement(Cell, {
  span: 1
}, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  height: 36,
  width: 36
})), /*#__PURE__*/React.createElement(Cell, {
  span: 8
}, /*#__PURE__*/React.createElement(SkeletonRectangle, {
  height: 18,
  marginTop: "6px"
}), /*#__PURE__*/React.createElement(SkeletonRectangle, {
  width: 130,
  height: 12,
  marginTop: "3px"
}))))));
//# sourceMappingURL=SkeletonRowLoader.js.map